/**
 * Customize to align with react request
 */

export const UPDATE_USER_REGISTRATION_QUERY_NO_BYPASS = {
	action: 'updateUserRegistration',
};

export * from '@/core/data/Content/_Person';
